<template>
    <div v-if="sheetopen" id="commonsheet" ref="sheet" class="dark" tabindex="0" @click="loadComponentData(false)" @keyup.esc="loadComponentData(false)">
        <div ref="wrapper" class="editor-wrapper" :style="sheetposition" @click.stop="">
            <component :is="dynamiccomponent" :data="dynamicdata" @changed="resetScrollPosition" />
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoComponent",
    props: {
        sheetopen: {
            type: Boolean
        },
        dark: {
            type: Boolean
        },
        dynamiccomponent: {
            type: Object,
            default: null
        },
        dynamicdata: {
            type: String,
            default: ''
        }
    },
    data: function() {
        return {};
    },
    computed: {
        sheetposition: function() {
            const h = `height:${window.innerHeight - 160}px;`;
            return this.sheetopen
                ? `margin-top:48px;${h}`
                : `margin-top:${window.innerHeight}px;${h}`;
        }
    },
    updated() {
        if (this.$refs.sheet) this.$refs.sheet.focus();
    },
   
    methods: {
        resetScrollPosition(evt) {
            this.dbg("[info-component]::resetScrollPosition", evt);
        },
        loadComponentData(tof) {
            this.$emit('loadcomponentdata', tof);
        },
    },
};
</script>

<style>

ul * {
    font-size: inherit;
}

#commonsheet {
    display: flex;
    top: 0;
    left: 0;
    bottom: 0px;
    right: 0px;
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    font-family: 'Helvetica Neue', Arial, sans-serif;
    color: #779;

    line-height: 1.5;
    margin: 0;
    padding: 0;
    font-size: 14px;
    -webkit-text-size-adjust: 100%;
    -webkit-font-smoothing: antialiased;
    justify-content: center;
    transition: all 0.3s linear;

    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    z-index: 900;
}

.commonsheet a {
    font-size: inherit;
}

.editor-wrapper {
    display: flex;
    justify-content: center;
    width: 80%;
    background: #efefef;
    box-shadow: 0px 2px 20px 12px rgba(0, 0, 0, 0.8);
    border: 1px solid #333;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    margin: 20px;
    margin-top: 1000px;
    /* transition: all 0.3s linear; */
    transition: opacity 1s linear;
}

#editor {
    width: 60%;
    overflow: scroll;
}

.inner {
    padding: 20px;
    width: 92%;
    height: auto;
}

/* .inner p:last-child::after {
    content: ' ';
    height: 120px;
    display: block;
} */

.inner::after {
    content: ' ';
    height: 60px;
    display: block;
}


.inner p > img {
    max-width: 60%;
    margin: 20%;
    margin-top: 0;
    margin-bottom: 0;
}

#editor div {
    /* display: inline-block; */
    vertical-align: top;
    box-sizing: border-box;
    padding: 0 20px;
}


ul * {
    list-style: none;
}

code {
    font-family: 'Lucida Console', 'Monaco', monospace;
    color: #99a;
    font-size: 14px;
    line-height: 15px;
}

td code {
    font-family: inherit;
    font-size: inherit;
}

/* img,
.editor img {
    max-width: 100%;
    margin: 0 auto;
    margin: 25px 0;
} */

table,
.table {
    display: table;
    border-collapse: separate;
    -webkit-border-horizontal-spacing: 2px;
    -webkit-border-vertical-spacing: 2px;
    /* border-top-color: gray; */
    /* background: transparent; */
}

table tr,
.table tr,
table th,
.table th,
table td,
.table td {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

thead,
table thead {
    border-bottom: 1px solid blue;
}

a {
    color: #aac;
}

h1,
h2,
h3,
h4,
h5 {
    border: none;
    /* color: #333333; */
    color: rgba(255,255,255,.3);
    font-weight: 600;
}

b,
i,
strong {
    color: #000033;
}

h1 {
    font-size: 30px;
    line-height: 36px;
    margin: 20px 0 30px !important;
}

h2 {
    font-size: 26px;
    line-height: 32px;
    margin: 14px 0 26px !important;
}

#commonsheet.dark,
.dark #commonsheet {
    color: #d8d8d8;
}

.dark .editor-wrapper {
    background: #1a1a1a;
}

.dark textarea {
    background-color: #666666;
}

.dark h1,
.dark h2,
.dark h3,
.dark h4,
.dark h5 {
    border: none;
    color: #eae7e1;
    font-weight: 600;
}

.dark b,
.dark i,
.dark strong {
    color: #c7c7c7;
}

.micro {
    max-width: 20px;
    margin: 1px;
}
</style>
